// Реестр моков для разработки без бэкенда. Регистрация ручек идёт из слайсов (modules/*/api),
// здесь — только сам реестр и резолвинг по методу + пути (с поддержкой `:param`).

import type { HttpMethod } from '../http/types'

export type MockHandler<TInput = any, TOutput = any> = (input: TInput) => TOutput | Promise<TOutput>

type MockEntry = {
  segments: string[]
  handler: MockHandler
}

const registry = new Map<HttpMethod, MockEntry[]>()

const MIN_DELAY_MS = 200
const MAX_DELAY_MS = 500

const splitPath = (path: string): string[] => path.split('/').filter(Boolean)

const delay = (): Promise<void> => {
  const ms = MIN_DELAY_MS + Math.random() * (MAX_DELAY_MS - MIN_DELAY_MS)
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Регистрирует обработчик мока. `path` может содержать `:param`, например `/users/:id` */
export function registerMock<TInput = any, TOutput = any>(
  method: HttpMethod,
  path: string,
  handler: MockHandler<TInput, TOutput>,
): void {
  const entries = registry.get(method) ?? []
  entries.push({ segments: splitPath(path), handler: handler as MockHandler })
  registry.set(method, entries)
}

/** Сбрасывает реестр — используется в тестах */
export function resetMockRegistry(): void {
  registry.clear()
}

function matchSegments(patternSegments: string[], pathSegments: string[]): boolean {
  if (patternSegments.length !== pathSegments.length) return false

  return patternSegments.every((segment, index) => {
    if (segment.startsWith(':')) return true
    return segment === pathSegments[index]
  })
}

/** Ищет и выполняет обработчик мока по методу и конкретному (уже подставленному) пути */
export async function resolveMock<TOutput = any>(
  method: HttpMethod,
  path: string,
  input: unknown,
): Promise<TOutput> {
  const entries = registry.get(method) ?? []
  const pathSegments = splitPath(path)

  const entry = entries.find((candidate) => matchSegments(candidate.segments, pathSegments))

  if (!entry) {
    // eslint-disable-next-line no-console
    console.error(`[mock] обработчик не найден для ${method} ${path}`)
    throw new Error(`[mock] обработчик не найден для ${method} ${path}`)
  }

  await delay()

  return entry.handler(input) as Promise<TOutput>
}
